// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import Actions from "../../actions/Creators";
import {
  Layout,
  ToggleButton,
  Loader,
  DatePicker,
  Button
} from "../../components/common/";
import I18n from "../../i18n/I18n";
import styles from "./Reports.scss";
import ReportCards from "../../components/reports/ReportCards";
import ReportsEmpty from "../../components/reports/ReportsEmpty";

type State = {
  fromDate: string,
  toDate: string
};

class Reports extends Component<void, State> {
  constructor() {
    super();

    this.state = {
      fromDate: "",
      toDate: "",
      reportsType: 1
    };
    this.selectedFromDate = this.selectedFromDate.bind(this);
    this.selectedToDate = this.selectedToDate.bind(this);
    this.clearDate = this.clearDate.bind(this);
    this.exportReports = this.exportReports.bind(this);
  }

  componentDidMount() {
    if (this.props.user && this.props.seller && this.state.reportsType === 1) {
      this.clearDate();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.seller !== nextProps.seller &&
      this.state.reportsType === 1
    ) {
      this.clearDate();
    }
  }

  selectedFromDate(date) {
    const formatted = moment(date).format();

    let toDate = this.state.toDate;

    if (moment(toDate).isBefore(moment(formatted))) {
      toDate = "";
    }

    var newState = {};
    newState["fromDate"] = formatted;
    newState["toDate"] = toDate;
    this.setState(newState);
  }

  selectedToDate(date) {
    const formatted = moment(date).format();

    var newState = {};
    newState["toDate"] = formatted;
    this.setState(newState);
  }

  clearDate() {
    this.setState({ fromDate: "", toDate: "" });
    this.props.dispatch(Actions.clearReports());
  }

  getReportsData(reportsType, fromDate, toDate) {
    let query = "/custom";
    switch (reportsType) {
      case 1:
        query = "/custom";
        break;
      case 3:
        query = "/month";
        break;
      case 2:
        query = "/week";
        break;
      default:
        query = "/custom";
    }

    query =
      fromDate && toDate
        ? `${query}?from_date=${fromDate}&to_date=${toDate}`
        : query;

    this.props.dispatch(Actions.getReports(query));
  }

  toggleReports = reportsType => {
    if (reportsType === 2) {
      this.getReportsData(reportsType);
    } else if (reportsType === 3) {
      this.getReportsData(reportsType);
    } else {
      this.clearDate();
    }
    this.setState({ reportsType });
  };

  rangeSubmit() {
    this.getReportsData(
      this.state.reportsType,
      this.state.fromDate,
      this.state.toDate
    );
  }

  exportReports(name, link) {
    const param = {
      from_date: this.state.fromDate,
      to_date: this.state.toDate
    };
    this.props.dispatch(Actions.exportReports(name, link, param));
  }

  filtered(reports) {
    if (this.state.reportsType !== 3) {
      _.remove(reports, function(currentObject) {
        return !currentObject.no_of_items || currentObject.no_of_items === "0";
      });
    }
    return reports;
  }

  render() {
    const reports = this.props.reports;
    const isReportsLoading = this.props.isLoading;
    const minimumDate = moment(this.state.fromDate || "");
    const maximumDate = moment(this.state.toDate || "");
    const minimumPaidAtDate = moment().subtract(1, "year");
    const maxDate = moment();

    return (
      <Layout currentIndex={5} title={"reports.title"}>
        <div className={styles.reportsCtr}>
          <div>
            <div className={styles.topWrapper}>
              <ToggleButton
                toggleBtn={this.toggleReports}
                toggleItems={[
                  I18n.getText("reports.custom"),
                  I18n.getText("reports.weekly"),
                  I18n.getText("reports.monthly")
                ]}
                selected={this.state.reportsType}
              />

              {this.state.reportsType === 1 ? (
                <div className={styles.datePicker}>
                  <div className={styles.label}>
                    {I18n.getText("reports.date-range", {}, "Date range")}
                  </div>
                  {I18n.getComponent(
                    formattedValue => (
                      <DatePicker
                        placeholder={"YYYY-MM-DD"}
                        initialDate={this.state.fromDate}
                        selectedDate={this.selectedFromDate}
                        clearDate={!this.state.fromDate}
                        isOutsideRange={day =>
                          day.isBefore(minimumPaidAtDate) ||
                          day.isAfter(maxDate) ||
                          day.isAfter(maximumDate)
                        }
                      />
                    ),
                    "reports.start-date"
                  )}
                  <div className={styles.label}>
                    {I18n.getText("reports.date-to", {}, "to")}
                  </div>
                  {I18n.getComponent(
                    formattedValue => (
                      <DatePicker
                        placeholder={"YYYY-MM-DD"}
                        selectedDate={this.selectedToDate}
                        initialDate={this.state.toDate}
                        clearDate={!this.state.toDate}
                        isOutsideRange={day =>
                          day.isBefore(minimumDate) || day.isAfter(maxDate)
                        }
                      />
                    ),
                    "reports.end-date"
                  )}
                  <Button
                    variant="transparent"
                    onClick={() => this.rangeSubmit()}
                    disabled={!this.state.fromDate || !this.state.toDate}
                  >
                    {I18n.getText("reports.generate-btn", {}, "Go")}
                  </Button>
                  <Button
                    variant="transparent"
                    onClick={this.clearDate}
                    className={styles.clear}
                    disabled={!this.state.fromDate && !this.state.toDate}
                  >
                    {I18n.getText("reports.clear", {}, "Clear")}
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
            {isReportsLoading ? (
              <Loader />
            ) : reports &&
            reports.reports &&
            reports.reports.reports &&
            !_.isEmpty(this.filtered(reports.reports.reports)) ? (
              <ReportCards
                data={this.filtered(reports.reports.reports)}
                exportReports={this.exportReports}
                isExportLoading={this.props.isExportLoading}
                reportsType={this.state.reportsType}
              />
            ) : (
              <ReportsEmpty reportsType={this.state.reportsType} />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = state => {
  return {
    lang: state.locale.lang,
    user: state.session.user,
    seller: state.session.seller,
    reports: state.reports,
    isLoading: state.reports.isLoading,
    isExportLoading: state.reports.isExportLoading,
    browser: state.browser
  };
};

export default connect(mapStateToProps)(Reports);



// WEBPACK FOOTER //
// ./src/containers/reports/Reports.js